'use client';

import { useLocale } from 'next-intl';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const PUBLIC_LANG_COOKIE = 'alix_public_lang';

type PublicLanguageSwitcherProps = {
  className?: string;
};

export function PublicLanguageSwitcher({ className }: PublicLanguageSwitcherProps) {
  const currentLocale = useLocale();

  const isVietnamese = currentLocale === 'vi';
  const switchTo = isVietnamese ? 'en' : 'vi';

  const handleSwitch = () => {
    const maxAge = 60 * 60 * 24 * 365; // 1 year
    document.cookie = `${PUBLIC_LANG_COOKIE}=${switchTo};path=/;max-age=${maxAge};SameSite=Lax`;
    window.location.reload();
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleSwitch}
      className={cn('gap-1.5 text-xs', className)}
    >
      <Globe className="h-3.5 w-3.5" />
      {isVietnamese ? 'English' : 'Tiếng Việt'}
    </Button>
  );
}
